import { IResponseProps } from '@/entities/Response'
import { ICompanyProps } from '@/entities/Company'

export const Types = {
  store: 'store',
  current: 'current',
  filter: 'filter'
}

export const path = 'company/'

export class Store implements FluxStandardAction<IResponseProps<ICompanyProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<ICompanyProps>) {}
}

export class Current implements FluxStandardAction<ICompanyProps | null> {
  type = path + Types.current
  constructor(public payload: ICompanyProps | null) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}
